import * as ng from 'angular';
import { ValidateIpv6 } from '../../../../../services';
import { FormInputModelOptions } from '../../../../atoms/form-elements';

export class MoleculeInputTextIpv6Controller implements ng.IController {
    public static $inject: string[] = ['$translate'];

    public validationErrorList = [];
    public value: string;
    public placeholder: string;
    public callbackOnChange: (arg0: any) => any;
    public callbackOnBlur: (arg0: any) => any;
    public callbackOnChangeParams: any;
    public callbackOnBlurParams: any;
    public disabled: boolean;
    public modelOptions: FormInputModelOptions;
    public registerToForm: boolean;
    public options: any;
    public validationInstructions: any[];
    public inputId: string;
    public callbackOnClear: (arg0: any) => any;
    public callbackOnClearParams: any;
    public clearable: boolean;

    constructor(
        private $translate: ng.translate.ITranslateService
    ) {}

    public $onInit() {
        let allowEmpty = true;
        let acceptPlaceholders = false;
        if (this.options != null && this.options !== undefined) {
            if (this.options.allowEmpty != null && this.options.allowEmpty !== undefined) {
                allowEmpty = this.options.allowEmpty;
            }
            if (this.options.acceptPlaceholders != null && this.options.acceptPlaceholders !== undefined) {
                acceptPlaceholders = this.options.acceptPlaceholders;
            }
        }
        this.validationInstructions = [
            {
                instructions: null,
                validator: new ValidateIpv6(this.$translate, allowEmpty, acceptPlaceholders)
            }
        ];
    }

    public $onChanges(changes) {
        if (
            changes.options !== undefined
            && changes.options.currentValue !== undefined
            && this.validationInstructions !== undefined
        ) {
            this.validationInstructions.map(
                (instruction) => {
                    if (instruction.validator.setAllowEmpty !== undefined) {
                        instruction.validator.setAllowEmpty(changes.options.currentValue.allowEmpty);

                        if (this.callbackOnBlur !== undefined) {
                            this.callbackOnBlur(this.callbackOnBlurParams);
                        }
                    }
                }
            );
        }
    }

    public onPaste = (paste) => {
        // implement callback on paste here when needed!
    };
}

export class MoleculeInputTextIpv6Component implements ng.IComponentOptions {
    public bindings = {
        callbackOnBlur: '<',
        callbackOnBlurParams: '<',
        callbackOnChange: '<',
        callbackOnChangeParams: '<',
        callbackOnClear: '<',
        callbackOnClearParams: '<',
        clearable: '<',
        customCallbackOnEnter: '<',
        disabled: '<',
        doNotSaveOnFormEnter: '<',
        inputId: '@?',
        modelOptions: '<',
        options: '<',
        placeholder: '@',
        registerToForm: '<',
        validationErrorList: '=?',
        value: '='
    };
    public controller = MoleculeInputTextIpv6Controller;
    public template = require('./input-text-with-validation-wrapper.html');
}
